import React, { useEffect, useState } from "react";
import { Card, Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { removeFromBasket } from "../../redux/slices/purchaseOrders";

const FloatingCart = ({ onSubmit }) => {
  const dispatch = useDispatch();
  const basket = useSelector((state) => state.purchaseOrders.basket);
  const [visible, setVisible] = useState(false);
  const user = useSelector((state) => state.user.user);
  const impersonationUser = useSelector(
    (state) => state.impersonationUser.impersonationUser
  );
  const [activeUser, setActiveUser] = useState({});
  const [vatRate, setVatRate] = useState(0.24); // Default VAT rate

  useEffect(() => {
    setActiveUser(impersonationUser?.id ? impersonationUser : user);
  }, [user, impersonationUser]);

  useEffect(() => {
    setVatRate(activeUser.country === "Greece" ? 0.24 : 0.0);
  });

  useEffect(() => {
    // Show cart only when basket is not empty
    setVisible(basket.length > 0);
  }, [basket]);

  const vatPrice = basket
    .reduce((sum, item) => sum + item.price * item.quantity * vatRate, 0)
    .toFixed(2);

  const subtotal = basket
    .reduce((sum, item) => sum + item.price * item.quantity, 0)
    .toFixed(2);

  const totalPrice = Number(subtotal) + Number(vatPrice);

  return (
    <div className={`floating-cart-container ${visible ? "show" : "hide"}`}>
      <Card
        style={{
          backgroundColor: "#042742",
          color: "#fff",
          borderRadius: "15px",
        }}
      >
        <Card.Body>
          <Card.Title
            style={{
              color: "#fff",
            }}
          >
            Your Cart
          </Card.Title>
          <ul
            className="list-unstyled"
            style={{
              maxHeight: "200px",
              overflowY: "auto",
              marginBottom: "10px",
            }}
          >
            {basket.map((item) => (
              <li
                key={item.id}
                className="mb-2 d-flex justify-content-between align-items-center"
              >
                <div>
                  <strong
                    style={{
                      color: "#fff",
                    }}
                  >
                    {item.simProduct.description}
                  </strong>
                  <br />
                  <small
                    style={{
                      color: "#fff",
                    }}
                  >
                    Qty: {item.quantity}
                  </small>
                </div>
                <div className="ms-2">
                  €{(item.quantity * item.price).toFixed(2)}
                  <Button
                    variant="link"
                    size="sm"
                    style={{ color: "#dc3545" }}
                    onClick={() =>
                      dispatch(removeFromBasket(item.catalogueSimProductId))
                    }
                  >
                    ✕
                  </Button>
                </div>
              </li>
            ))}
          </ul>
          <hr style={{ borderColor: "#666" }} />
          <div className="d-flex justify-content-between align-items-center">
            <strong
              style={{
                color: "#fff",
              }}
            >
              Subtotal:
            </strong>
            <strong
              style={{
                color: "#fff",
              }}
            >
              €{subtotal}
            </strong>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <strong
              style={{
                color: "#fff",
              }}
            >
              VAT {(vatRate * 100).toFixed(0)}%:
            </strong>
            <strong
              style={{
                color: "#fff",
              }}
            >
              €{vatPrice}
            </strong>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <strong
              style={{
                color: "#fff",
              }}
            >
              Total:
            </strong>
            <strong
              style={{
                color: "#fff",
              }}
            >
              €{totalPrice.toFixed(2)}
            </strong>
          </div>
          <div className="text-center mt-3">
            <Button
              variant="primary"
              style={{ backgroundColor: "#04addc", border: "none" }}
              onClick={onSubmit}
            >
              Checkout
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default FloatingCart;
